const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/return/myapproval`;
const URL_APPROVAL = `${process.env.REACT_APP_API_URL}/return/approval`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const postApproval = (payload) => {
  return axios.post(URL_APPROVAL, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};